import axios from 'axios'
import vue from '../main'
import qs from 'qs'
import { Notification, Message } from 'element-ui'
// import Vue from 'vue'
// import store from '../store'
const request = axios.create({
  timeout: 40000,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json; charset=UTF-8'
  }
})

// axios 全局配置
request.defaults.paramsSerializer = function (params) {
  return qs.stringify(params, { arrayFormat: 'repeat', allowDots: true })
};

// 允许携带cookie
request.defaults.withCredentials = true

const codeMessage = {
  400: '请求参数错误',
  401: '登录态失效，请重新登录',
  403: '您的权限不足',
  404: '请求数据不存在',
  406: '请求的格式不正确',
  410: '请求的资源已被永久删除',
  422: '当创建一个对象时，发生一个验证错误',
  500: '服务器发生错误',
  502: '网关错误',
  503: '服务不可用，服务器暂时过载或维护',
  504: '网关超时'
}

// 请求拦截器
request.interceptors.request.use(
  config => {
    if (config.headers['Custom-Params']) {
      config.baseURL = vue.$JavaUrl
    } else {
      config.baseURL = vue.$NewUrl
    }
    const requestConfig = config
    // if (store.state.token) {
    //   requestConfig.headers.Authorization = `Bearer ${store.state.token}`
    // }
    return requestConfig
  },
  err => {
    Promise.reject(err).then(res => { })
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    // 正确返回
    if (response.status === 200) {
      if (response.data.code === 0) {
        // 列表
        if (response.data.data) {
          if (response.data.data.content instanceof Array) {
            response.data.data = {
              list: {
                data: response.data.data.content,
                current_page: response.data.data.pageInfo.pageNumber,
                total: response.data.data.pageInfo.total,
              }
            }
          } else {

          }
          response.data.msg = response.data.message === '成功' ? "获取成功" : "获取失败"
        }
      }


      // 判断请求头 - 是导出就结束
      if (response.headers['content-disposition'] !== undefined) {
        const fileName = decodeURIComponent(response.headers['content-disposition'].split('attachment;filename=')[1])
        return [response.data, fileName]
      }
      if (response.data.code === 0) {
        if (response.data.msg !== undefined && response.data.msg !== '获取成功' && response.data.msg !== '') {
          Message({ type: 'success', customClass: 'messageNew', offset: 11, message: response.data.msg })
        }
      } else {
        // 错误提示
        Notification.error({ title: '错误提示 [' + response.data.code + ']', message: response.data.msg })
      }
    } else {
      let message = codeMessage[response.status]
      // if (response.data && response.data.message) {
      //   message = response.data.message
      // }
      // 错误提示
      Notification.error({ title: message + '[' + response.data.code + ']', message: response.data.msg })
    }
    return response.data
  },
  error => {
    let message = codeMessage[error.response.status]
    if (error.response.status === 401) {
      // 判断当前页面 已经登录就不弹框了
      if (vue.$route.path === '/Login') {
        return Promise.reject(error)
      }
      // 统一前往登录页
      Notification.error({ title: message + '[' + error.response.data.code + ']', message: error.response.data.msg })
      // 删除存储
      localStorage.removeItem('userInfo')
      // 返回登陆页
      vue.$router.push({ name: 'Login' })
    } else if (error.response.status === 504) {
      // 错误提示
      Notification.error({ title: message, message: '请稍后再继续尝试...' })
    } else {
      // 错误提示
      Notification.error({ title: message + '[' + error.response.data.code + ']', message: error.response.data.msg })
    }
    return Promise.reject(error)
  }
)

export default request



// WEBPACK FOOTER //
// ./src/utils/javaHttp.js